import React from 'react'
import cn, { Argument as ClassName } from 'classnames'

export type LandingMessageSuccessIconProps = {
    className?: ClassName
    style?: React.CSSProperties
}

export function LandingMessageSuccessIcon({ className, style }: LandingMessageSuccessIconProps): React.ReactElement {
    return (
        <svg
            width={90}
            height={90}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={cn(className)}
            style={style}
        >
            <g fill="#81E18B">
                <path d="m30.03 52.553 7.364 7.375 30.94-30.941 1.044 1.043-31.985 31.985-8.407-8.42-2.536-2.54-5.578-5.588 1.044-1.042 5.578 5.587 2.536 2.54Z" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M45 1.475C20.962 1.475 1.475 20.962 1.475 45S20.962 88.525 45 88.525 88.525 69.038 88.525 45 69.038 1.475 45 1.475ZM0 45C0 20.147 20.147 0 45 0s45 20.147 45 45-20.147 45-45 45S0 69.853 0 45Z"
                />
            </g>
        </svg>
    )
}
